<div class="modal-body">
  <p class="centermodal__title">{{ 'documents.addSignatory' | translate }}</p>

  <div class="centermodal__form">
    <div class="d-flex">
      <app-signer-input
        [signer]="signer"
        [document]="document"
        [qualified]="document.qualified"
        [isCountryBR]="document.locale?.country === 'BR'"
        [validationErrors]="validationErrors?.signers"
        [class.has-error]="validationErrors.signer?.name || validationErrors.signer?.email"
        [attr.signer-color-id]="0"
        [context]="SignerInputContext.CreateSigner"
        (changeSigner)="onSignerChange()"
      ></app-signer-input>
    </div>
  </div>

  <div class="centermodal__button-group">
    <button type="button" class="btn-M btn-filled-cancel" [disabled]="isLoading" (click)="modal.dismiss()">{{ 'button.close' | translate }}</button>
    <button type="button" class="btn-M btn-filled btn--credits" [disabled]="isLoading" (click)="create(signer)">
      {{ 'documents.addSignatory' | translate }}
      <span class="credits" *ngIf="appService.totalCreditPrice([signer]) > 0">
        <div class="credits__content">
          <i class="fal fa-shield-check"></i>
          -{{ appService.totalCreditPrice([signer]) }}
        </div>
      </span>
    </button>
  </div>
</div>
